module.exports = __webpack_public_path__ + "img/success.22adb454.png";